import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";

import { INITIAL_FORM } from "./scheda/SchedaConstants";
import { SchedaListView } from "./scheda/SchedaListView";
import { SchedaSummaryView } from "./scheda/SchedaSummaryView";
import { SchedaFormView } from "./scheda/SchedaFormView";

const SchedaEpisodio = ({ onBack }) => {
  const [view, setView] = useState("list");
  const [episodes, setEpisodes] = useState([]);
  const [form, setForm] = useState(INITIAL_FORM);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expandedSection, setExpandedSection] = useState(1);
  const [viewingEpisode, setViewingEpisode] = useState(null);

  useEffect(() => { fetchEpisodes(); }, []);

  const fetchEpisodes = async () => {
    try {
      const res = await api.get('/assertivita/episodes');
      setEpisodes(res.data || []);
    } catch {
      // Expected on first use: no episodes exist yet
    }
  };

  const handleSave = async () => {
    if (!form.descrizione.trim()) {
      toast.error("Descrivi cosa \u00e8 accaduto");
      return;
    }
    setLoading(true);
    try {
      if (editingId) {
        await api.put(`/assertivita/episodes/${editingId}`, form);
        toast.success("Scheda aggiornata!");
      } else {
        await api.post('/assertivita/episodes', form);
        toast.success("Scheda salvata!");
      }
      setForm(INITIAL_FORM);
      setEditingId(null);
      setView("list");
      fetchEpisodes();
    } catch {
      toast.error("Errore nel salvataggio");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (episodeId) => {
    if (!window.confirm("Eliminare questa scheda?")) return;
    try {
      await api.delete(`/assertivita/episodes/${episodeId}`);
      toast.success("Scheda eliminata");
      fetchEpisodes();
      if (viewingEpisode?.episode_id === episodeId) {
        setViewingEpisode(null);
        setView("list");
      }
    } catch {
      toast.error("Errore nell'eliminazione");
    }
  };

  const handleNewScheda = () => {
    setForm(INITIAL_FORM);
    setEditingId(null);
    setView("new");
    setExpandedSection(1);
  };

  const handleViewSummary = (episode) => {
    setViewingEpisode(episode);
    setView("summary");
  };

  const handleEditFromSummary = () => {
    if (viewingEpisode) {
      setForm({ ...INITIAL_FORM, ...viewingEpisode });
      setEditingId(viewingEpisode.episode_id);
      setView("edit");
      setExpandedSection(1);
    }
  };

  if (view === "list") {
    return (
      <SchedaListView
        episodes={episodes}
        onBack={onBack}
        onNewScheda={handleNewScheda}
        onViewSummary={handleViewSummary}
        onDelete={handleDelete}
      />
    );
  }

  if (view === "summary" && viewingEpisode) {
    return (
      <SchedaSummaryView
        episode={viewingEpisode}
        onBack={() => { setView("list"); setViewingEpisode(null); }}
        onEdit={handleEditFromSummary}
      />
    );
  }

  // Form view (new/edit)
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <Button variant="ghost" size="sm" onClick={() => setView("list")} className="rounded-full">
          <ArrowLeft className="w-4 h-4 mr-1" /> Indietro
        </Button>
      </div>
      <SchedaFormView
        form={form}
        setForm={setForm}
        editingId={editingId}
        expandedSection={expandedSection}
        setExpandedSection={setExpandedSection}
        loading={loading}
        onSave={handleSave}
      />
    </div>
  );
};

export default SchedaEpisodio;
